var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("or-sidebar", {
    attrs: {
      "data-component": "base-settings-page-sidebar",
      width: _vm.MIN_WIDTH,
      "min-width": _vm.MIN_WIDTH,
      "max-width": _vm.MAX_WIDTH,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "title-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _vm.isEditMode
                        ? _c("or-input", {
                            attrs: { error: _vm.titleError, required: "" },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onEditDone.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.localTitle,
                              callback: function ($$v) {
                                _vm.localTitle = $$v
                              },
                              expression: "localTitle",
                            },
                          })
                        : _c(
                            "span",
                            { attrs: { "data-title": "sidebar-name" } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.localTitle) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isTitleEditable
                    ? [
                        _vm.isEditMode
                          ? _c("or-icon-button", {
                              class: { "icon-disabled": _vm.titleError },
                              attrs: { icon: "done", size: _vm.IconSize.L },
                              on: { click: _vm.onEditDone },
                            })
                          : _c("or-icon-button", {
                              attrs: {
                                icon: "mode_edit",
                                size: _vm.IconSize.L,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isEditMode = true
                                },
                              },
                            }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "default",
          fn: function () {
            return [
              _vm._t("default"),
              _vm._v(" "),
              _c("or-confirm", {
                attrs: {
                  "is-open": _vm.isClosePopupOpen,
                  "title-text": _vm.$t(
                    "HITL.modules.common-settings.sidebar.close-title"
                  ),
                },
                on: {
                  confirm: function ($event) {
                    return _vm.$emit("close-confirm")
                  },
                  close: function ($event) {
                    return _vm.$emit("close-cancel")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _vm.tItemLabel
                          ? _c(
                              "i18n",
                              {
                                attrs: {
                                  slot: "content",
                                  path: "HITL.modules.common-settings.sidebar.close-description-update",
                                },
                                slot: "content",
                              },
                              [
                                _c(
                                  "strong",
                                  {
                                    staticStyle: { "word-break": "break-all" },
                                    attrs: { slot: "text" },
                                    slot: "text",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.tItemLabel) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "HITL.modules.common-settings.sidebar.close-description-create"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ],
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c("or-confirm", {
                attrs: {
                  "is-open": _vm.isDeletePopupOpen,
                  "title-text": _vm.$t(_vm.deletePopupTitle, {
                    item: _vm.itemLabel,
                  }),
                  loading: _vm.deleteButtonState === "loading",
                  "auto-close-on-confirm": false,
                  "confirm-type": "d",
                },
                on: {
                  confirm: function ($event) {
                    return _vm.$emit("delete-confirm")
                  },
                  close: function ($event) {
                    return _vm.$emit("delete-cancel")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function () {
                      return [
                        _c(
                          "i18n",
                          {
                            attrs: {
                              slot: "content",
                              path: _vm.deletePopupMessage,
                            },
                            slot: "content",
                          },
                          [
                            _c(
                              "strong",
                              {
                                staticStyle: { "word-break": "break-word" },
                                attrs: { slot: "item" },
                                slot: "item",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.tItemLabel) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _vm.deleteButtonTooltip
                    ? _c(
                        "or-tooltip",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.deleteButtonTooltip) +
                                        "\n        "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            970898883
                          ),
                        },
                        [
                          _c(
                            "div",
                            [
                              _vm.showDeleteButton
                                ? _c(
                                    "or-button",
                                    {
                                      attrs: {
                                        "data-button": "delete",
                                        variant: "outlined",
                                        disabled: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("HITL.common.actions.delete")
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm.showDeleteButton
                    ? _c(
                        "or-button",
                        {
                          attrs: {
                            "data-button": "delete",
                            color: "danger",
                            variant: "outlined",
                            loading: _vm.deleteButtonState === "loading",
                            disabled: _vm.deleteButtonState === "disabled",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("delete")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("HITL.common.actions.delete")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "or-button",
                        {
                          attrs: {
                            "data-button": "cancel",
                            variant: "outlined",
                            loading: _vm.cancelButtonState === "loading",
                            disabled: _vm.cancelButtonState === "disabled",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("cancel")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t(_vm.cancelButtonLabel)) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showSuccessButton
                        ? _c(
                            "or-button",
                            {
                              attrs: {
                                "data-button": "save",
                                loading: _vm.successButtonState === "loading",
                                disabled: _vm.successButtonState === "disabled",
                              },
                              on: { click: _vm.onSuccessClick },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.successButtonLabel) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }